import { ExpandedStation, Position, Station } from 'pages/Map/types';
import { NodeList } from '../../../Path/path-points-utils/types';
import { X_SCALE_VALUE } from 'constants/map';
import colors from 'theme/colors';
import { SubZoneStation } from '../SubZone';

export const getTruncatedDescription = (description: string, limit: number) => {
    const lastSpace = description.substring(0, limit).lastIndexOf(' ');
    return description.substring(0, lastSpace) || description.split(' ')[0];
};

export const getFixedInterval = (scale: number) => {
    return Number(scale.toFixed(1));
};

/**
 * Takes the station position and checks if any path point in the right of the station
 * Path points are generally at x, x + halfXScale and x + xScale.
 * So checking in the middle point so that it will cover both horizontal and vertialcal paths in middle
 */
export const checkAnyPathUnderDescription = (stationPosition: Position, pathNodeList: NodeList) => {
    const { x, y } = stationPosition;
    const xForPathCheck = x + X_SCALE_VALUE / 2; //halfway in the right of station
    /* eslint-disable @typescript-eslint/no-unnecessary-condition */
    return pathNodeList.nodeX[xForPathCheck] && pathNodeList.nodeX[xForPathCheck].filter(({ point }) => point === y).length >= 1;
};

export const getSectionColor = (sectionIndex: number) => {
    if (sectionIndex % 2 === 0) {
        return colors.grey[200];
    }

    return colors.grey[50];
};

export const getBackgroundColor = (
    station: Station,
    expandedStation: ExpandedStation,
    hasPathUnderDescription: boolean,
    sectionIndex: number
) => {
    const isLastStationInExpandedSubzone =
        expandedStation instanceof SubZoneStation &&
        station.parentStation &&
        station.parentStation.id === expandedStation.id &&
        expandedStation.bottomMostChild.yPosition === station.yPosition;
    if (isLastStationInExpandedSubzone) {
        return colors.white;
    }

    if (!hasPathUnderDescription) {
        return '';
    }

    const isSubzoneStation =
        expandedStation &&
        expandedStation instanceof SubZoneStation &&
        [station.parentStation?.id, station.id].includes(expandedStation.id);
    if (isSubzoneStation) {
        return colors.white;
    }

    return getSectionColor(sectionIndex);
};
